<template>
  <ul class="list_tape_container">
    <li class="list_tape_item"
      :class="{selected: isSelected(id)}"
      :key="id"
      v-for="{id, name, filename} in item_list"
      @click="updateItem(id)"
    >
      <figure class="list_tape_wrapper">
        <div class="tape_img__wrapper">
          <img class="list_tape_img" :src="`item_image/parts/${filename}`" width="71" height="567" loading="lazy" />
        </div>
        <figcaption class="list_tape_name">{{ name }}</figcaption>
      </figure>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    item_list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('simulator', ['editing_parts']),
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapActions('simulator', ['updateItemInfo']),
    isSelected (id) {
      return id === this.editing_parts?.tape
    },
    async updateItem(id) {
      await this.updateItemInfo({
        item_data: {
          name_tape: id,
          width_tape: 200,
          height_tape: 200
        },
        parts: {...this.editing_parts, tape: id }
      })
      this.setModal('')
    }
  }
}
</script>

<style lang="scss" scoped>
  .list_tape_container {
    display: flex;
    flex-flow: row wrap;
    margin: 0 calc(-8.5 / 295 * 100%);
    padding: 0;
    .list_tape_item {
      margin: calc(5 / 312 * 100%) calc(8.5 / 312 * 100%);
      flex: 0 0 auto;
      flex-basis: calc(35 / 312 * 100%);
      list-style: none;
      &.selected {
        .list_tape_wrapper {
          border: 2px solid #000;
        }
      }
      .list_tape_wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0;
        .tape_img__wrapper {
          position: relative;
          width: calc(21 / 35 * 100%);
          &::before {
            display: block;
            content: '';
            padding-top: calc(63 / 21 * 100%);
          }
          .list_tape_img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
</style>